import store from '../store';

export const Language = {
  ENG: 'en',
  RUS: 'ru',
};
export const LocalStorageFields = {
  USER: 'user',
  LANG: 'lang',
  SCALE: 'scale',
  LOGOUT_COUNTER: 'logCounter',
  IS_DARK: 'isDark',
  INTERVAL_TIME: 'intervalTime',
  BANK_FILTER: 'bankFilter',
  BRANCH_FILTER: 'branchFilter',
  KEEP_FILTERS: 'keepFilters',
};

// вместо констант используем функции, чтобы данные подгружались после запроса к серверу настроек
export const DefaultValues = {
  LANG: () => store.getters.DEFAULT_LANG,

  USER_OBJ: {
    [LocalStorageFields.LANG]: () => store.getters.DEFAULT_LANG,
    [LocalStorageFields.SCALE]: () => 720,
    [LocalStorageFields.LOGOUT_COUNTER]: () => 0,
    [LocalStorageFields.IS_DARK]: () => store.getters.DEFAULT_DARK_THEME,
    [LocalStorageFields.INTERVAL_TIME]: () => 30,
    [LocalStorageFields.KEEP_FILTERS]: () => false,
  },
};
